__turbopack_context__.v({
  "actionLinks": "productRatings-module-scss-module__3Oioma__actionLinks",
  "disabled": "productRatings-module-scss-module__3Oioma__disabled",
  "likeALink": "productRatings-module-scss-module__3Oioma__likeALink",
  "productReviewsModal": "productRatings-module-scss-module__3Oioma__productReviewsModal",
  "submitReviewSuccessToast": "productRatings-module-scss-module__3Oioma__submitReviewSuccessToast",
  "wrapper": "productRatings-module-scss-module__3Oioma__wrapper",
});
